<template>
  <div class="hero-banner critical-component-clear">
    <div
      class="hero-banner__container"
      :class="`text-colour--${banner.heading.textColour}`"
    >
      <div class="hero-banner__media">
        <template v-if="banner.mobileVideo || banner.desktopVideo">
          <video-player
            v-if="banner.mobileVideo"
            class="hero-banner__mobile-video"
            :attributes="banner.videoSettings"
            :image="banner.mobileVideo.preview_image"
            :lazyload="banner.lazyload"
            :loaded-animation="false"
            :ratio="settings.ratio"
            :intersection-observer="{
              enable: banner.videoSettings.autoplay,
            }"
            sizes="100vw"
            :sources="banner.mobileVideo.sources"
          />

          <video-player
            v-if="banner.desktopVideo"
            class="hero-banner__desktop-video"
            :attributes="banner.videoSettings"
            :image="banner.desktopVideo.preview_image"
            :lazyload="banner.lazyload"
            :loaded-animation="false"
            :ratio="settings.ratioDesktop"
            :intersection-observer="{
              enable: banner.videoSettings.autoplay,
            }"
            sizes="100vw"
            :sources="banner.desktopVideo.sources"
          />
        </template>

        <template v-if="banner.mobileImage?.url || banner.desktopImage?.url">
          <art-direction
            v-if="banner.mobileImage?.url && !banner.mobileVideo"
            class="hero-banner__mobile-image"
            :image="banner.mobileImage"
            :image-desktop="banner.mobileImage"
            :ratio="settings.ratio"
            :ratio-desktop="settings.ratio"
            :loaded-animation="false"
            :lazyload="banner.lazyload"
          />
          <art-direction
            v-if="banner.desktopImage?.url && !banner.desktopVideo"
            class="hero-banner__desktop-image"
            :image="banner.desktopImage"
            :image-desktop="banner.desktopImage"
            :ratio="settings.ratioDesktop"
            :ratio-desktop="settings.ratioDesktop"
            :loaded-animation="false"
            :lazyload="banner.lazyload"
          />
        </template>

        <div
          v-if="banner.enableOverlay"
          class="hero-banner__overlay"
          :style="`background-color: rgba(0,0,0,${banner.overlayRange})`"
        />
      </div>

      <div
        class="hero-banner__content grid"
        :class="{ 'stretched-link-container': banner.headingLink }"
      >
        <div :class="banner.alignVertical">
          <heading-copy
            :class="banner.alignHorizontal"
            :classes="{
              copy: 'text-body-s-regular text-body-m-regular-desktop',
            }"
            :content="banner.heading"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Hero banner (hero-banner)
 * -----------------------------------------------------------------------------
 * Section featuring a full width image or video and overlayed text content.
 * - Dynamic section.
 *
 * @param {Object} banner - Section banner.
 * @param {String} settings.sectionId - Section's Liquid ID.
 * @param {String} settings.ratio - Image's Ratio on Mobile devices.
 * @param {String} settings.ratioDesktop - Image's Ratio on Destkop devices.
 *
 */
import ArtDirection from '~global/images/art-direction'
import HeadingCopy from '~async/heading-copy/heading-copy'
import VideoPlayer from '~async/video-player/video-player'

export default {
  name: 'HeroBanner',

  components: {
    ArtDirection,
    HeadingCopy,
    VideoPlayer,
  },

  props: {
    settings: {
      type: Object,
      default: () => ({}),
    },
    banner: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>

<style lang="scss">
@import './hero-banner';
@import '../video-player/video-player';
</style>
